import React, { useState } from 'react';
import ExcelJS from 'exceljs';
import {
  formatPrice,
  LoadingGrid,
} from '../../../../../rbts/helpers';
import Select from 'react-select';
import { useReporteVentas } from '../hooks/CortesiasHook';
import { styleSelect } from '../../../../../rbts/assets/ts/_utils';
import { useObtenerDiasPorEvento } from '../../cortesias/hooks/CortesiasHook';
import { useObtenerTodasCajas } from '../../../treasury/box_delivery/hooks';

type Props = {};

const productos = [
  {
    id: 1,
    value: 'Brazalete',
    label: 'Brazalete',
  },
  {
    id: 2,
    value: 'TicketCash',
    label: 'TicketCash',
  },
];

const Vista: React.FC<Props> = ({}) => {
  const [diaSeleccionado, setDiaSeleccionado] = useState<any | null>([]);
  const [prodSeleccionado, setProdSeleccionado] = useState<any | null>([]);
  const [idDia, setIdDia] = useState<number>(0);
  const [idCaja, setIdCaja] = useState<number>(0);
  const [nombreProducto, setNombreProducto] = useState<string>('');
  const [reloadInfo, setReloadInfo] = useState<number>(Math.random() * 40);
  const { list, ingresos, loadingRequest } = useReporteVentas(
    reloadInfo,
    idDia,
    idCaja,
    nombreProducto
  );
  const { list: listadosDeDias, loadingRequest: cargandoDias } =
    useObtenerDiasPorEvento(reloadInfo);

  const [selectedOptionPOS, setSelectedOptionPOS] = useState<any | null>(null);
  const [reloadPOS, setReloadPOS] = useState(Math.random() * 40);
  const { catalog: POS, loadingRequest: loadingPOS } = useObtenerTodasCajas(
    reloadPOS,
    false
  );

  const headerStyle: React.CSSProperties = { backgroundColor: '#8e949f' };
  const totalStyle: React.CSSProperties = { backgroundColor: '#f0f1f5', boxShadow: 'none', border: 'none' };

  const grouped = list.reduce((acc: Record<string, { items: typeof list; subtotal: number }>, item) => {
    if (!acc[item.producto]) acc[item.producto] = { items: [], subtotal: 0 };
    acc[item.producto].items.push(item);
    acc[item.producto].subtotal += Number(item.costo_total);
    return acc;
  }, {});
  const groups = Object.entries(grouped);

  // DESCARGA EXCEL

  const [loadingDownload, setLoadingDownload] = React.useState(false);
  const columnsExcel: any = ['Producto', 'Tipo', 'Cantidad', 'Costo Total'];
  const handleDownloadExcel = async () => {
    setLoadingDownload(true);
    try {
      await exportTableToExcel(list, columnsExcel, `reporte_ventas.xlsx`);
    } catch (error) {
      console.error('Error downloading Excel:', error);
    } finally {
      setLoadingDownload(false);
    }
  };

  const exportTableToExcel = async (
    data: any[],
    columns: string[],
    filename = 'tabla.xlsx'
  ) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(`Ventas`);

    if (idDia > 0) {
      worksheet.addRow([`Día Administrativo:`, diaSeleccionado.label]);
    }
    if (idCaja > 0) {
      worksheet.addRow([`Caja:`, selectedOptionPOS.label]);
    }
    if (nombreProducto) {
      worksheet.addRow([`Producto:`, nombreProducto]);
    }

    if (idDia > 0 || idCaja > 0 || nombreProducto) {
      worksheet.addRow([]);
      worksheet.addRow([]);
    }

    worksheet.addRow(['Producto', 'Tipo', 'Cantidad', 'Costo Total']);
    worksheet.columns = [
      { width: 30 },
      { width: 20 },
      { width: 15 },
      { width: 25 },
    ];

    data.forEach((item) => {
      const producto = item.producto;
      const efectivo = item.efectivo ? 'Efectivo' : 'Tarjeta';
      const cantidad = Number(item.cantidad);
      const costo_total = Number(item.costo_total);
      worksheet.addRow([producto, efectivo, cantidad, costo_total]);
    });

    worksheet.addRow([]);
    worksheet.addRow([]);

    worksheet.addRow([
      '',
      '',
      'Total Efectivo',
      ingresos.ingreso_efectivo ? ingresos.ingreso_efectivo : 0,
    ]);
    worksheet.addRow([
      '',
      '',
      'Total Tarjeta',
      ingresos.ingreso_tarjeta ? ingresos.ingreso_tarjeta : 0,
    ]);
    worksheet.addRow([
      '',
      '',
      'Total General',
      (ingresos.ingreso_efectivo ? ingresos.ingreso_efectivo : 0) +
        (ingresos.ingreso_tarjeta ? ingresos.ingreso_tarjeta : 0),
    ]);

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const handleSupplierOnChange = (selectedOption: any) => {
    if (selectedOption) {
      setDiaSeleccionado(selectedOption);
      setIdDia(selectedOption.id);
    } else {
      setDiaSeleccionado(null);
      setIdDia(0);
    }
  };

  const changePOS = (selectedOption: any) => {
    if (selectedOption) {
      const { value } = selectedOption;
      setSelectedOptionPOS(selectedOption);
      setIdCaja(value);
    } else {
      setSelectedOptionPOS(null);
      setIdCaja(0);
    }
  };

  const handleProductOnChange = (selectedOption: any) => {
    if (selectedOption) {
      setProdSeleccionado(selectedOption);
      setNombreProducto(selectedOption.value);
    } else {
      setProdSeleccionado(null);
      setNombreProducto('');
    }
  };

  return (
    <>
      <div className="d-flex flex-column flex-xl-row">
        <div className="col-xl-12">
          <div className="card mb-6 mb-xl-9">
            <div className="card-header border-0 pt-5">
              <div className="card-title">
                <div className="w-300px pe-5 fs-7 text-gray-700">
                  <div className="w-100 d-flex">
                    <label className="form-label w-auto">
                      Día administrativo:{' '}
                    </label>
                  </div>
                  <Select
                    options={listadosDeDias}
                    value={diaSeleccionado}
                    styles={styleSelect}
                    placeholder={'Seleccione'}
                    className="w-100"
                    isSearchable={true}
                    noOptionsMessage={() => {
                      return <span>{'No se encontraron registros'}</span>;
                    }}
                    onChange={handleSupplierOnChange}
                    isLoading={loadingRequest}
                    isClearable
                    backspaceRemovesValue
                  />
                </div>
                <div className="w-300px pe-5 fs-7 text-gray-700">
                  <div className="w-100 d-flex">
                    <label className="form-label w-auto">Caja: </label>
                  </div>
                  <Select
                    options={POS}
                    value={selectedOptionPOS}
                    styles={styleSelect}
                    placeholder={'Seleccione'}
                    isSearchable={true}
                    noOptionsMessage={() => {
                      return <span>{'No se encontraron registros'}</span>;
                    }}
                    onChange={changePOS}
                    isLoading={loadingPOS}
                    isClearable
                    backspaceRemovesValue
                  />
                </div>
                <div className="w-300px pe-5 fs-7 text-gray-700">
                  <div className="w-100 d-flex">
                    <label className="form-label w-auto">Producto: </label>
                  </div>
                  <Select
                    options={productos}
                    value={prodSeleccionado}
                    styles={styleSelect}
                    placeholder={'Seleccione'}
                    className="w-100"
                    isSearchable={true}
                    noOptionsMessage={() => {
                      return <span>{'No se encontraron registros'}</span>;
                    }}
                    onChange={handleProductOnChange}
                    isClearable
                    backspaceRemovesValue
                  />
                </div>
              </div>
              <div className="card-toolbar">
                <div className="d-flex rounded mt-3">
                  {list.length > 0 && (
                    <button
                      className="btn btn-sm btn-light-success"
                      disabled={loadingDownload}
                      onClick={() => handleDownloadExcel()}
                    >
                      {loadingDownload ? (
                        <span
                          className="indicator-progress"
                          style={{ display: 'block' }}
                        >
                          Descargando...
                          <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                      ) : (
                        <>
                          {/* <KTSVG
                            path="/media/icons/duotune/files/fil030.svg"
                            className="svg-icon-5 svg-icon-gray-500 me-3"
                          /> */}
                          Descargar
                        </>
                      )}
                    </button>
                  )}
                </div>
              </div>
            </div>

            <div className="card-body pt-3">
              {loadingRequest ? (
                <LoadingGrid text="Cargando..." />
              ) : groups.length === 0 ? (
                <div className="text-center text-muted py-8 fs-6">
                  No se encontraron ventas registradas.
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-hover table-rounded table-striped border gy-4 gs-7">
                    <thead>
                      <tr className="fw-bolder fs-7 text-gray-800 border-bottom border-gray-200">
                        <th>Tipo</th>
                        <th className="text-center">Cantidad</th>
                        <th className="text-end">Costo Total</th>
                      </tr>
                    </thead>
                    {groups.map(([producto, group]) => (
                      <tbody
                        key={producto}
                        style={{ outline: '2px solid #c2c6d0', outlineOffset: '-1px' }}
                      >
                        <tr style={headerStyle}>
                          <td
                            colSpan={3}
                            className="fw-bolder fs-7 ps-3 py-2"
                            style={{ color: '#1e3a5f' }}
                          >
                            {producto}
                          </td>
                        </tr>
                        {group.items.map((item, idx) => (
                          <tr key={idx} className="align-middle">
                            <td className="fs-7">
                              <span
                                className={`badge ${
                                  item.efectivo
                                    ? 'badge-light-warning'
                                    : 'badge-light-primary'
                                }`}
                              >
                                {item.efectivo ? 'Efectivo' : 'Tarjeta'}
                              </span>
                            </td>
                            <td className="text-center fs-7">{item.cantidad}</td>
                            <td className="text-end fs-7 fw-semibold">
                              {formatPrice(item.costo_total ?? 0, 'es-MX', 'MXN', 2, 2)}
                            </td>
                          </tr>
                        ))}
                        <tr style={totalStyle}>
                          <td
                            colSpan={2}
                            className="text-end fs-7 fw-bolder"
                            style={{ color: '#1e3a5f' }}
                          >
                            Subtotal:
                          </td>
                          <td
                            className="text-end fs-7 fw-bolder"
                            style={{ color: '#1a7a4a' }}
                          >
                            {formatPrice(group.subtotal, 'es-MX', 'MXN', 2, 2)}
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={3} style={{ height: '10px', padding: 0 }} />
                        </tr>
                      </tbody>
                    ))}
                  </table>

                  <div className="d-flex justify-content-end mt-4">
                    <table className="table table-bordered w-auto" style={{ minWidth: '300px' }}>
                      <tbody>
                        <tr>
                          <td className="fw-bold fs-7 text-end pe-4" style={{ color: '#1e3a5f' }}>
                            Total Efectivo:
                          </td>
                          <td
                            className="fw-bolder fs-7 text-end"
                            style={{ color: '#1a7a4a', minWidth: '130px' }}
                          >
                            {formatPrice(ingresos.ingreso_efectivo ?? 0, 'es-MX', 'MXN', 2, 2)}
                          </td>
                        </tr>
                        <tr>
                          <td className="fw-bold fs-7 text-end pe-4" style={{ color: '#1e3a5f' }}>
                            Total Tarjeta:
                          </td>
                          <td className="fw-bolder fs-7 text-end" style={{ color: '#1a7a4a' }}>
                            {formatPrice(ingresos.ingreso_tarjeta ?? 0, 'es-MX', 'MXN', 2, 2)}
                          </td>
                        </tr>
                        <tr style={totalStyle}>
                          <td className="fw-bolder fs-7 text-end pe-4" style={{ color: '#1e3a5f' }}>
                            Total General:
                          </td>
                          <td className="fw-bolder fs-6 text-end" style={{ color: '#1a7a4a' }}>
                            {formatPrice(
                              (ingresos.ingreso_efectivo ?? 0) + (ingresos.ingreso_tarjeta ?? 0),
                              'es-MX',
                              'MXN',
                              2,
                              2
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { Vista };
